export const SEND_NEWSLETTER_NOTIFICATION_REQUEST = 'notification/SEND_NEWSLETTER_NOTIFICATION_REQUEST';
export const SEND_NEWSLETTER_NOTIFICATION_SUCCESS = 'notification/SEND_NEWSLETTER_NOTIFICATION_SUCCESS';
export const SEND_NEWSLETTER_NOTIFICATION_FAILURE = 'notification/SEND_NEWSLETTER_NOTIFICATION_FAILURE';

export const RESEND_NEWSLETTER_NOTIFICATION_REQUEST = 'notification/RESEND_NEWSLETTER_NOTIFICATION_REQUEST';
export const RESEND_NEWSLETTER_NOTIFICATION_SUCCESS = 'notification/RESEND_NEWSLETTER_NOTIFICATION_SUCCESS';
export const RESEND_NEWSLETTER_NOTIFICATION_FAILURE = 'notification/RESEND_NEWSLETTER_NOTIFICATION_FAILURE';

export const INIT_NOTIFICATION = 'notification/INIT_NOTIFICATION';

export const sendNewsletterNotificationRequest = (payload = {}) => ({
  type: SEND_NEWSLETTER_NOTIFICATION_REQUEST,
  payload,
});
export const sendNewsletterNotificationSuccess = (payload = {}) => ({
  type: SEND_NEWSLETTER_NOTIFICATION_SUCCESS,
  payload,
});
export const sendNewsletterNotificationFailure = (payload = {}) => ({
  type: SEND_NEWSLETTER_NOTIFICATION_FAILURE,
  payload,
});

export const resendNewsletterNotificationRequest = (payload = {}) => ({
  type: RESEND_NEWSLETTER_NOTIFICATION_REQUEST,
  payload,
});
export const resendNewsletterNotificationSuccess = (payload = {}) => ({
  type: RESEND_NEWSLETTER_NOTIFICATION_SUCCESS,
  payload,
});
export const resendNewsletterNotificationFailure = (payload = {}) => ({
  type: RESEND_NEWSLETTER_NOTIFICATION_FAILURE,
  payload,
});

export const initNotification = (payload = {}) => ({
  type: INIT_NOTIFICATION,
  payload,
});
